import apiClient, { prefetchApiCsrfToken } from "../common";
import type { BuyOrder } from "../types";
import { buildLineItems } from "./createSupplyDocument";

const JSON_API_MEDIA = "application/vnd.api+json";

/**
 * PATCH /api/v1/supply-documents/{id}/ — reemplaza los renglones de una OC
 * ya persistida. El editor del simulador manda siempre el listado completo,
 * así que una orden sin productos viaja con `line-items: []` para vaciarla,
 * nunca sin la clave (eso significaría "no tocar los renglones").
 */
export async function apiUpdateSupplyDocumentLines(
  documentId: string,
  order: BuyOrder,
): Promise<void> {
  await prefetchApiCsrfToken();
  await apiClient.patch(
    `supply-documents/${documentId}/`,
    {
      data: {
        type: "supply-documents",
        id: documentId,
        attributes: {
          "line-items": buildLineItems(order),
        },
      },
    },
    {
      headers: {
        Accept: JSON_API_MEDIA,
        "Content-Type": JSON_API_MEDIA,
      },
    },
  );
}
